export { default } from './ChattelDetailsSection';
